export default __webpack_public_path__ + "static/media/credit_card.c16f4f7b.svg";